<nav class="navbar navbar-expand-lg" [ngClass]="[bgNav,navBarText]">
  <a class="navbar-brand" [routerLink]="['/modulo']">{{ usuario.entidade.nomeApresentacao ?
    usuario.entidade.nomeApresentacao : usuario.entidade.razaoSocial }}</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto">
      <ng-container *ngFor="let m of menu">
        <app-menu-modulo-item *ngIf="!m.menuItens" [item]="m"></app-menu-modulo-item>
        <app-menu-modulo-subitem [bg]="bgSub" [bgSub]="bgSub2" *ngIf="m.menuItens" [menu]="m"></app-menu-modulo-subitem>
      </ng-container>
    </ul>
    <ul class="navbar-nav">
      <li class="nav-item dropdown">
        <a class="nav-link" data-toggle="dropdown" href="#" (click)="carregarNotificacoes()">
          <i class="fas fa-bell"></i>
          <span class="badge badge-warning navbar-badge" *ngIf="unreadCount > 0">{{ unreadCount }}</span>
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
          <span class="dropdown-item dropdown-header">
            {{ unreadCount }} Notificação{{ unreadCount === 1 ? '' : 'ões' }} não lida{{ unreadCount === 1 ? '' : 's' }}
          </span>
          <div class="dropdown-divider"></div>
          <div *ngIf="notificacoesLoading" class="dropdown-item text-muted small">
            Carregando...
          </div>
          <ng-container *ngIf="!notificacoesLoading">
            <a href="#" class="dropdown-item" *ngFor="let item of notificacoes"
              (click)="marcarLida($event, item)">
              <i class="fa fa-info-circle mr-2" [class.text-warning]="!item.lida"></i>
              {{ item.titulo }}
              <span class="float-right text-muted text-sm">{{ item.data }}</span>
              <div class="text-muted small text-truncate">{{ item.descricao }}</div>
            </a>
            <div class="dropdown-divider" *ngIf="notificacoes.length === 0"></div>
            <span class="dropdown-item text-muted small" *ngIf="notificacoes.length === 0">
              Nenhuma notificação recente.
            </span>
          </ng-container>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item text-center" *ngIf="unreadCount > 0"
            (click)="marcarTodasLidas($event)">
            Marcar todas como lidas
          </a>
          <div class="dropdown-divider" *ngIf="unreadCount > 0"></div>
          <a href="#" class="dropdown-item dropdown-footer" (click)="verTodas($event)">
            Ver todas as notificações
          </a>
        </div>
      </li>
      <li class="nav-item dropdown dropleft text">
        <a class="nav-link" data-toggle="dropdown" href="#">
          <i class="fa fa-user mr-2"></i>
        </a>
        <ul class="dropdown-menu">
          <!-- User image -->
          <li class="user-header">
            <div style="text-align: center">
              <i class="fa fa-user text-muted" style="font-size:32px"></i>
              <p class="text-muted p-1">{{ usuario.nome }}<br>
              </p>
            </div>
          </li>
          <br />
          <!-- Menu Footer-->
          <li class="user-footer d-flex justify-content-between">
            <div>
              <a [routerLink]="['/seguranca/alterar-senha']" title="Alterar Senha" [ngClass]="layout.navColor.colorBtn"
                class="btn ml-2"><i class="fas fa-user-shield"></i></a>
            </div>
            <div>
              <button (click)="logout()" title="Sair" [ngClass]="layout.navColor.colorBtn" class="btn mr-2"><i
                  class="fas fa-sign-out-alt"></i></button>
            </div>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</nav>